import React from 'react';
import './ModalSicaiPlans.css';

const PLANS = [
  { name: 'SICAI Web', price: '' },
  { name: 'SICAI Estándar', price: '' },
  { name: 'SICAI Pro', price: '$4,058.84' },
  { name: 'SICAI Ilimitado', price: '$7,538.84' },
  { name: 'SICAI Server', price: '$8,118.84' },
  { name: 'SICAI Server Ilimitado', price: '$11,598.84' }
];

const RAW_FEATURES = [
  ['Timbrado ilimitado', '000101'],
  ['Servicio 100% en línea', '100000'],
  ['Adaptable a equipos móviles y de escritorio', '100000'],
  ['Emisión y timbrado de facturas', '111111'],
  ['Emisión y timbrado de nómina', '111111'],
  ['Emisión y timbrado de complementos de recepción de pagos', '111111'],
  ['Emisión y timbrado de complementos de impuestos locales', '111111'],
  ['Administración de productos', '111111'],
  ['Administración de clientes', '111111'],
  ['Cancelación', '111111'],
  ['Multiempresa', '011111'],
  ['Control de accesos', '011111'],
  ['Complemento INE', '101111'],
  ['Servicios parciales de construcción', '101111'],
  ['Complementos Notarios Públicos', '101111'],
  ['Complementos Comercio exterior', '101111'],
  ['Emisión y timbrado de comprobantes de retenciones y sus complementos', '101111'],
  ['Importación de productos y clientes', '001111'],
  ['Verificación de estatus de comprobantes en el SAT', '101111'],
  ['Órdenes de compra', '001111'],
  ['Cotizaciones', '001111'],
  ['Tickets de venta', '001111'],
  ['Generación de reportes en Excel', '101111'],
  ['Cálculo de nómina', '001111'],
  ['Generación de nómina con datos precargados', '101111'],
  ['Almacén (inventario y existencias)', '001111'],
  ['Punto de venta', '001111'],
  ['Cortes de caja y cortes programados', '001111'],
  ['Reportes de venta', '001111'],
  ['Bancos', '001111'],
  ['Cuentas por pagar', '001111'],
  ['Cuentas por cobrar', '001111'],
  ['Funcionamiento en red', '100011'],
  ['Acceso simultáneo de usuarios', '100011'],
  ['Control total de tus sucursales', '000011'],
  ['Validación y verificación de CFDIs recibidos', '100000']
];

const FEATURES = RAW_FEATURES.map((r, i) => ({
  name: r[0],
  bg: i % 2 ? '#FAF8F6' : '#ffffff',
  cells: r[1].split('').map((v) => ({
    yes: v === '1',
    no: v !== '1',
    label: v === '1' ? 'Sí' : 'No'
  }))
}));

const ModalSicaiPlans = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleGoToContact = (e) => {
    e.preventDefault();
    onClose();
    setTimeout(() => {
      const contactEl = document.querySelector('#contacto');
      if (contactEl) {
        const headerOffset = 70;
        const elementPosition = contactEl.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 50);
  };

  return (
    <div className="df-plans-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="planes-titulo">
      <div className="df-plans-modal-backdrop" onClick={onClose} aria-hidden="true" />

      <div className="df-plans-modal-dialog">
        {/* Cabecera Oficial */}
        <div className="df-plans-modal-header">
          <div className="df-plans-modal-header-titles">
            <h2 id="planes-titulo" className="df-plans-modal-title">
              Compara las versiones de SICAI
            </h2>
            <p className="df-plans-modal-subtitle">Los precios incluyen IVA</p>
          </div>

          <button
            type="button"
            className="df-plans-modal-close-btn"
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        {/* Tabla Oficial con Scroll Horizontal y Vertical */}
        <div className="df-plans-modal-scroll">
          <div className="df-plans-table-wrapper">
            {/* Cabecera Oscura Sticky */}
            <div className="df-plans-sticky-header">
              <div className="df-plans-th-features">Características</div>
              {PLANS.map((pl, idx) => (
                <div key={idx} className="df-plans-th-plan">
                  <span className="df-plans-th-name">{pl.name}</span>
                  {pl.price ? <span className="df-plans-th-price">{pl.price}</span> : null}
                </div>
              ))}
            </div>

            {/* Filas de Características */}
            <div className="df-plans-rows-container">
              {FEATURES.map((ft, idx) => (
                <div
                  key={idx}
                  className="df-plans-row"
                  style={{ backgroundColor: ft.bg }}
                >
                  <div className="df-plans-td-name">{ft.name}</div>
                  {ft.cells.map((c, cIdx) => (
                    <div key={cIdx} className="df-plans-td-cell">
                      {c.yes ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#1E7B4F"
                          strokeWidth="2.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <path d="M5 12.5l4.5 4.5L19 7.5" />
                        </svg>
                      ) : (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#9AA0AB"
                          strokeWidth="2.6"
                          strokeLinecap="round"
                          aria-hidden="true"
                        >
                          <path d="M6 12h12" />
                        </svg>
                      )}
                      <span className="df-visually-hidden">{c.label}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Pie Oficial del Modal */}
        <div className="df-plans-modal-footer">
          <a
            href="#contacto"
            className="df-plans-btn-advisory"
            onClick={handleGoToContact}
          >
            Quiero una asesoría
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModalSicaiPlans;
